import { ExperimentType } from 'modules/graphql';
import { BaseCellWrapper } from './Styled';

type BaseCellProps = {
  value: string | ExperimentType;
};
export const BaseCell = ({ value }: BaseCellProps) => <BaseCellWrapper>{value}</BaseCellWrapper>;
